module.exports = __webpack_public_path__ + "static/summer-23c0e91c3900e0f80a634315369d2966.jpg";